<template>
  <div class="accordion">
    <div class="accordion--title-row">
      <editor v-model="val" @change="change" />
      <div>
        <button @click="open = !open" v-text="open ? '-' : '+'"></button>
        <button @click="deleting = true">Delete</button>
        <ModalWindow v-if="deleting" @close="deleting = false">
          <h3 style="margin-top: 0">Are you sure?</h3>
          <p>
            This will delete {{ node.nodes.length }} node{{
              node.nodes.length == 1 ? "" : "s"
            }}
          </p>
          <div style="display: flex; justify-content: space-between">
            <button @click="deleting = false">Cancel</button>
            <button @click="deleteThis()">Yes</button>
          </div>
        </ModalWindow>
      </div>
    </div>
    <Sections
      v-if="open"
      :nodes="getNodes(node.id)"
      :parent-id="'' + node.id"
      :node="node"
    ></Sections>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Sections from "@/components/Sections.vue";
import Editor from "./Editor.vue";
import ModalWindow from "./ModalWindow.vue";

export default {
  components: {
    Sections,
    Editor,
    ModalWindow,
  },
  data() {
    return {
      open: false,
      val: this.node.title,
      deleting: false,
    };
  },
  watch: {
    val(val) {
      console.log("changed!");
      if (this.t) {
        clearTimeout(this.t);
        this.t = null;
      }
      this.t = setTimeout(() => {
        console.log("update");
        this.$store.commit("updateNode", { nodeId: this.node.id, html: val });
      }, 200);
    },
  },
  methods: {
    ...mapActions(["deleteAnything"]),
    deleteThis() {
      this.deleteAnything(this.node.id);
    },
    change(e) {
      this.val = this.$refs.ta.innerHTML;
    },
  },
  name: "Accordion",
  props: ["node"],
  computed: {
    ...mapGetters(["getNodes"]),
    showNodes() {},
  },
};
</script>

<style lang="scss">
</style>
